module.exports = require('./helpers/bundle-url').getBundleURL('ciDtH') + "not-found.6a9ec007.svg";